import {Injectable} from '@angular/core';

import {Title} from '@angular/platform-browser';
import * as SharedModels from '@shared-models/index';
import {ActivatedRoute, NavigationEnd, Router, RouterEvent} from '@angular/router';
import {filter, map, mergeMap} from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class CookieConsentService {
    init(): void {
        // tslint:disable
        const cookieConsent = window['__env'].cookieConsent;
        if (!cookieConsent) {
            return;
        }
        const { src, domainScript } = cookieConsent;

        const openComment = document.createComment('OneTrust Cookies Consent Notice start for dbadge.deloitte.com');
        const closeComment = document.createComment('OneTrust Cookies Consent Notice end for dbadge.deloitte.com');

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.defer = true;
        script.charset = 'UTF-8';
        script.src = src;
        script.dataset.domainScript = domainScript;

        document.head.appendChild(openComment);
        document.head.appendChild(script);
        document.head.appendChild(closeComment);

        // Define OptanonWrapper globally without adding an inline <script> to avoid CSP violations
        (window as any).OptanonWrapper = (window as any).OptanonWrapper || function () { };
    }
}
